/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */





// hide show table and image block size popup
$(function() {

  
    $(".img_toggle_btn").click(function() {
        $(".btn_bottom_wrpper").hide();
        $('.upper_table').slideUp('slow', function(){
          $('.image_blockss').slideDown(300);
       });
      
    });

  $(".arrow_backto_upper").click(function() {
        $(".btn_bottom_wrpper").show();
        $(".upper_table").show();
        $(".image_blockss").hide();
     
    });
});

// script for drag table
let mouseDown = false;
let startX, scrollLeft;
const slider = document.querySelector('.cata-sub-nav .TableWrapper');

const startDragging = (e) => {
  mouseDown = true;
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
}

const stopDragging = (e) => {
  mouseDown = false;
}

const move = (e) => {
  e.preventDefault();
  if(!mouseDown) { return; }
  const x = e.pageX - slider.offsetLeft;
  const scroll = x - startX;
  slider.scrollLeft = scrollLeft - scroll;
}

// Add the event listeners
slider.addEventListener('mousemove', move, false);
slider.addEventListener('mousedown', startDragging, false);
slider.addEventListener('mouseup', stopDragging, false);
slider.addEventListener('mouseleave', stopDragging, false);


// size popup close outside
  var overlay = document.querySelector(".size_modal_overlay");
  var popup = document.getElementById("modal-size-chart-men");
  overlay.onclick = function () {
    $('.Modal__Close').trigger('click');
  };

 var overlay = document.querySelector(".size_modal_overlay");
  var popup = document.getElementById("modal-size-chart-women");
  overlay.onclick = function () {
    $('.Modal__Close').trigger('click');
  };



// new arrow size chart
	$(".scroll-toggle__button--right").on("click", function(){
		$(".cata-sub-nav .TableWrapper").animate( { scrollLeft: '+=160' }, 200);
    });
		$(".scroll-toggle__button--left").on("click", function(){
		$(".cata-sub-nav .TableWrapper").animate( { scrollLeft: '-=160' }, 200);
	});

// filter media
$(document).ready(function(){

  $('.Product__SlideshowNav').css('display','block');
  var imgTxtBind = $('.pro_wrap .cart_drawer_pro:checked').data('imgbind');
  console.log(imgTxtBind);
  if(imgTxtBind){
 
    $('.pro_wrap .varBindImg').removeClass('filtercolor');
    $('.pro_wrap .varBindImg').not(`[data-bindvar="${imgTxtBind}"]`).addClass('filtercolor');
    $('.pro_wrap .varBindImg[data-varimg="true"]').removeClass('filtercolor');
    
     setTimeout(function(){
    
        $('.pro_wrap .varBindImg:not(.filtercolor)').css('opacity','1');
        $('.pro_wrap .Product__SlideshowNavScroller .varBindImg:not(.filtercolor)')
        .removeClass('is-selected') 
        .first()                      
        .addClass('is-selected'); 
         var newSliderr = $('.Product__Slideshow');
         var flkty = false
  
  
        if (document.querySelector('.Product__Slideshow.Carousel.flickity-enabled')) {
          flkty = new Flickity('.Product__Slideshow.Carousel.flickity-enabled');
          flkty.destroy();
        }
      
     
        
        flkty = newSliderr.flickity({
          draggable: true,
          contain: true,
          wrapAround: false,
          groupCells: false,  // Fixed typo from 'gorupCells' to 'groupCells'
          cellAlign: "center",
          prevNextButtons: true,
          pageDots: false,
          imagesLoaded: false,
          adaptiveHeight: true,
          cellSelector: ".Product__SlideItem:not(.filtercolor)",
          arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
        }).data('flickity');
  
     
       onClickThumbNail(newSliderr);
       // thumnail reinit
        thumbnailReinit();
  
     },2000);

    $('.Product__Slideshow').on('change.flickity', function (data, index){
      console.log(index);
      $('.pro_wrap .Product__SlideshowNavScroller .varBindImg:not(.filtercolor)').removeClass('is-selected');
      $('.Product__SlideshowNavScroller a.Product__SlideshowNavImage:not(.filtercolor)').each(function(i){
        var indexInner = i;
        // console.log(indexInner);
        if(indexInner == index){
           $(this).addClass('is-selected');
        }
      });
    });
    
  }


    
  
});


document.addEventListener('variant:changed', function(event) {
  
   if($('.cart_drawer_pro.ColorSwatch__Radio').length > 1){
     
      event.preventDefault();
      event.stopPropagation();
    
      variantImage();
      if($('.pro_wrap .cart_drawer_pro:checked').data('imgbind')){
        $('.Product__Slideshow.Carousel .varBindImg').css('visibility','hidden');
      }
     

      return false;
   }


  // code for show note message
  //  var checkedNoteEle = $(".SizeSwatchList.sizelist_wrp .SizeSwatch__Radio[type='radio']:checked").attr('data-shownote');
  var checkedNoteEleText = $(".SizeSwatchList.sizelist_wrp .SizeSwatch__Radio[type='radio']:checked").attr('data-sizenotemessage');
  var checkInvetoryQty = parseInt($(".SizeSwatchList.sizelist_wrp .SizeSwatch__Radio[type='radio']:checked").attr('data-inventoryqty'));
  var checkInventoryPolicy = $(".SizeSwatchList.sizelist_wrp .SizeSwatch__Radio[type='radio']:checked").attr('data-inventorypolicy');

  if (checkedNoteEleText && checkedNoteEleText.trim() !== '') {
    $('.size_note_messg span').html(' ' + checkedNoteEleText);
    $('.size_note_messg').removeClass('hidden');
  } else {
    $('.size_note_messg').addClass('hidden');
    $('.size_note_messg span').html(''); // clear old text
  }
  // if(checkedNoteEle == 'true'){
  //   $('.size_note_messg').removeClass('hidden');
  // }else{
  //   $('.size_note_messg').addClass('hidden');
  // }
  console.log(checkInvetoryQty);
  console.log(checkInventoryPolicy);
  // shipping message change
  if(checkInvetoryQty <= 0 && checkInventoryPolicy == 'continue'){
    // if variant inventory qty is <= 0
    $('.shipping-badge.ctm_hideshow.soldout').hide();
    $('.shipping-badge.ctm_hideshow.avaiableVariant').hide();
  }else{
    console.log(event.detail.variant);
    var variantAvail = event.detail.variant.available;
    if(variantAvail){
      $('.shipping-badge.ctm_hideshow.avaiableVariant').show();
      $('.shipping-badge.ctm_hideshow.soldout').hide();
    }else{
      $('.shipping-badge.ctm_hideshow.avaiableVariant').hide();
      $('.shipping-badge.ctm_hideshow.soldout').show();
    }
  }
    
  
  
});
  // if variant inventory qty is <= 0 onload
$(document).ready(function(){
  var checkInvetoryQty = parseInt($(".SizeSwatchList.sizelist_wrp .SizeSwatch__Radio[type='radio']:checked").attr('data-inventoryqty'));
  var checkInventoryPolicy = $(".SizeSwatchList.sizelist_wrp .SizeSwatch__Radio[type='radio']:checked").attr('data-inventorypolicy');
   console.log(checkInvetoryQty);
  console.log(checkInventoryPolicy);
  if(checkInvetoryQty <= 0 && checkInventoryPolicy == 'continue'){
    // if variant inventory qty is <= 0
    $('.shipping-badge.ctm_hideshow.soldout').hide();
    $('.shipping-badge.ctm_hideshow.avaiableVariant').hide();
  }
});
function variantImage(){
 

  setTimeout(function(){
  
    var imgTxtBind = $('.pro_wrap .cart_drawer_pro:checked').data('imgbind');
    if(imgTxtBind){
      
   
        $('.pro_wrap .varBindImg').removeClass('filtercolor');
        
            $('.pro_wrap .varBindImg').each(function() {
            if ($(this).data('bindvar') !== imgTxtBind) {
              $(this).addClass('filtercolor');
            }
          });
  
          // $('.pro_wrap .varBindImg').not(`[data-bindvar="${imgTxtBind}"]`).addClass('filtercolor');
          // $('.pro_wrap .varBindImg[data-varimg="true"]').removeClass('filtercolor');
    
        $('.pro_wrap .varBindImg:not(.filtercolor)').css('opacity','1');
        $('.pro_wrap .Product__SlideshowNavScroller .varBindImg:not(.filtercolor)')
        .removeClass('is-selected') 
        .first()                      
        .addClass('is-selected'); 
        var newSliderr = $('.Product__Slideshow');
        var $thumbSlider = $('.nav_gallary_main_wrp .carousel-nav');
        // console.log(newSliderr);
  
        if($('.Product__Slideshow.Carousel.flickity-enabled').length){
       
          newSliderr.flickity('destroy');
            
          newSliderr.flickity({
            draggable: true,
            contain: true,
            wrapAround: false,
            gorupCells: false,
            cellAlign: "center",
            prevNextButtons: true,
            pageDots: false,
            imagesLoaded: false,
            adaptiveHeight: true,
            sync: ".Product__SlideshowNavScroller",
            cellSelector: ".Product__SlideItem:not(.filtercolor)",
            arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
          });

          
          
        }
       
        
        $('.Product__Slideshow.Carousel.flickity-enabled.is-draggable .varBindImg').css('visibility','visible');
        onClickThumbNail(newSliderr);
        // thumnail reinit
        thumbnailReinit();
   }
   
  },500);
}

// function thumbnailReinit(){
//   console.log("thumb reinit");
//   var thumbCarouselElement = document.querySelector('.carousel-nav');
//   var thumbnailFlkty = Flickity.data(thumbCarouselElement);
//   thumbnailFlkty.resize();
// }
function thumbnailReinit() {
  console.log("thumb reinit");

  var thumbCarouselElement = document.querySelector('.carousel-nav');
  if (!thumbCarouselElement) return;

  // destroy old instance if exists
  var oldFlkty = Flickity.data(thumbCarouselElement);
  if (oldFlkty) {
    oldFlkty.destroy();
  }

  // count thumbnails again
  var thumbCount = thumbCarouselElement.querySelectorAll('.carousel-cell').length;

  // reinitialize
  var flkty = new Flickity(thumbCarouselElement, {
    wrapAround: false,
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    cellAlign: "left",
    asNavFor: ".carousel-main"
  });
}

function onClickThumbNail(newSliderr){
  if($('.Product__Slideshow--custom .flickity-slider')){
  
  $('.Product__SlideshowNavScroller a.Product__SlideshowNavImage:not(.filtercolor)').each(function(i){
      var index = i;
      // console.log(index);
    $(this).on('click',function(){
    $('.pro_wrap .Product__SlideshowNavScroller .varBindImg:not(.filtercolor)').removeClass('is-selected');
     newSliderr.flickity( 'select', index );
      $(this).addClass('is-selected');
    });

     
    
  })
  
  }
}



document.addEventListener('click', function (event) {
  const triggerSelector = '[data-tooltip-btn]';
  const boxSelector = '[data-tooltip-box]';

  // If clicked on trigger or inside it
  const trigger = event.target.closest(triggerSelector);
  if (trigger) {
    const wrapper = trigger.closest('.media-tooltip-wrapper');
    const tooltipBox = wrapper.querySelector(boxSelector);

    // Close all others
    document.querySelectorAll(boxSelector).forEach(box => {
      if (box !== tooltipBox) box.classList.remove('active');
    });

    // Toggle current
    tooltipBox.classList.toggle('active');
    return;
  }

  // If clicked inside tooltip → do nothing
  if (event.target.closest(boxSelector)) return;

  // Clicked outside → close all
  document.querySelectorAll(boxSelector).forEach(box => {
    box.classList.remove('active');
  });
});

/* product gallry with thumnail js start here */
/* product gallry with thumnail js start here */

document.addEventListener("DOMContentLoaded", function () {
  var $main = $('.nav_gallary_main_wrp .carousel-main');
  var $nav  = $('.nav_gallary_main_wrp .carousel-nav');

  // Get flickity instances
  var flktyMain = $main.data('flickityConfig'); 
  var flktyNav  = $nav.data('flickity');


  function adjustThumbNavHeight() {
    if (!flktyNav) return;

    var mainHeight = $main.find('.flickity-viewport').height();

    $('.nav_gallary_main_wrp .carousel-nav').css({
      maxWidth: mainHeight + 'px'
    });

 
    // Force Flickity to recalc selected index
    flktyNav.x = flktyNav.x;
    flktyNav.selectedIndex = flktyNav.selectedIndex;
  }


  if($(window).innerWidth() > 1023){
    adjustThumbNavHeight();
    
    $(window).on('resize', function () {
      setTimeout(function () {
        adjustThumbNavHeight();
      }, 100);
    });
  }

});



/* product gallry with thumnail js end here */
/* product gallry with thumnail js end here */